export const configObj = {
    baseUrl: 'https://uatpay.indusind.bank.in/ethccx',
    key: 'enEthcred78cc6ui',
    remainingOtpAttempts : 3,
    remainingLoginAttempts: 5,
    feedbackBaseUrl:'https://uatpay.indusind.bank.in/ethccx',
    benefitBaseUrl:'https://uatpay.indusind.bank.in/iblethdashboard',
    rewardFeatureV1:true,
    rewardFeatureV2:true,
    rewardFeatureV2Key:"rewards like never before!",
    whatsAppConsentBaseUrl:"https://uatpay.indusind.bank.in/ethccx/acquisition/capture/whatsapp/consent",
    rewardFeatureV2FlipkartKey:"flipkart bonanza offer!",
    rewardFeatureV2TimesPrimeKey:"it's a prime time deal for you!",
    timesPrimeMembershipAmount:"₹1,199"
};